import { useMemo } from 'react'
import { collection, limit, orderBy, query } from 'firebase/firestore'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { firebase_firestore } from '../../../common/firebaseConfig'
import { AlertHistoryItem } from '../types/AlertHistoryItem'

// Each day document holds every fire for that day, so two days is always enough for a short list
const DAY_DOCS_TO_READ = 2

// Latest `max` fires of an alert, newest first, streamed from Firestore
export function useAlertRecentHistory(alertId: string | undefined, max: number) {
  const historyQuery = useMemo(
    () =>
      alertId
        ? query(
            collection(firebase_firestore, `tradingPlans/${alertId}/alertNotificationHistory`),
            orderBy('date', 'desc'),
            limit(DAY_DOCS_TO_READ)
          )
        : null,
    [alertId]
  )

  const [dayDocs, loading, error] = useCollectionData<any>(historyQuery)

  const items = useMemo<AlertHistoryItem[]>(() => {
    if (!dayDocs) return []
    return (
      dayDocs
        .flatMap((day) => (Array.isArray(day.history) ? (day.history as AlertHistoryItem[]) : []))
        // Backend-written, but a malformed entry would sort as NaN and skew the NEW-badge window
        .filter((item) => typeof item?.time === 'number' && Number.isFinite(item.time))
        .sort((a, b) => b.time - a.time)
        .slice(0, max)
    )
  }, [dayDocs, max])

  return { items, loading, error }
}
